export default {
  tips: {
    areaNoPermission:
      'Playturbo’s video and image production service is not available in your country/region.',
  },
  useless: 'Cannot be Used',
}
